import {Component, Input, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {selectEntity} from "@digidom/common";
import {Deal, DealsService} from "@digidom/crm";
import {IonicAlertService} from "@digidom/ionic-common";
import {ModalController} from "@ionic/angular";
import {Router} from "@angular/router";
import {ObjectDescriptor} from "../../../../../../../../../libs/entity/src/lib/models/object-descriptor";

@Component({
  selector: 'hub-deal-modal',
  templateUrl: './deal-modal.component.html',
  styleUrls: ['./deal-modal.component.scss']
})
export class DealModalComponent implements OnInit {

  @Input()
  public id: string | undefined;

  @Input()
  personId: string | undefined;

  @Input()
  sourceObject?: ObjectDescriptor;

  @Input()
  organizationId: string | undefined;

  deal$: Observable<Deal | undefined> | undefined;

  constructor(public dealsService: DealsService,
              public alertService: IonicAlertService,
              public modalCtrl: ModalController,
              public router: Router) {
  }

  ngOnInit(): void {
    this.deal$ = selectEntity(this.dealsService, this.id);
  }

  async delete() {
    const alert = await this.alertService.createAlert({
      header: 'Delete Deal',
      message: 'Delete deal?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        }, {
          text: 'Delete',
          role: 'confirm',
          cssClass: 'danger'
        }
      ]
    }, {
      confirm: () => {
        if (!this.id){
          throw new Error('missing id');
        }
        this.dealsService.delete(this.id);
        this.close();
      }
    });

    await alert.present();
  }

  async close() {
    await this.modalCtrl.dismiss();
  }

  async closeAndNavigate(deal: Deal) {

    await this.modalCtrl.dismiss(deal, 'create');
    await this.router.navigate(['/deals', deal.id]);
  }

}
